import script from "./SettingsAll.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsAll.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsAll.vue?vue&type=style&index=0&id=05abf9f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05abf9f8"]])

export default __exports__